import { DesktopSidebar } from '@/components/navigation/desktop-sidebar';
import { DesktopTopBar } from '@/components/navigation/desktop-top-bar';
import { MobileDrawer } from '@/components/navigation/mobile-drawer';
import { useResponsiveShellOptional } from '@/providers/responsive-shell-provider';
import React from 'react';
import { View } from 'react-native';

interface ResponsiveShellProps {
  children: React.ReactNode;
}

export function ResponsiveShell({ children }: ResponsiveShellProps) {
  const shell = useResponsiveShellOptional();

  if (!shell) {
    return <>{children}</>;
  }

  const { isDesktop, isLargeDesktop, isAuthenticated, drawerOpen, closeDrawer, onCheckIn, unreadCount } = shell;

  if (!isAuthenticated) {
    return <>{children}</>;
  }

  if (isLargeDesktop) {
    return (
      <View className="flex-1">
        <DesktopTopBar unreadCount={unreadCount} onCheckIn={onCheckIn} />
        <View className="flex-1 items-center">
          <View style={{ flex: 1, maxWidth: 1030, width: '100%' }}>
            {children}
          </View>
        </View>
      </View>
    );
  }

  if (isDesktop) {
    return (
      <View className="flex-1 items-center">
        <View style={{ flexDirection: 'row', width: '100%', maxWidth: 1030, flex: 1 }}>
          <DesktopSidebar unreadCount={unreadCount} onCheckIn={onCheckIn} />
          <View style={{ flex: 1, maxWidth: 750 }}>
            {children}
          </View>
        </View>
      </View>
    );
  }

  return (
    <View className="flex-1">
      <MobileDrawer
        isOpen={drawerOpen}
        onClose={closeDrawer}
        unreadCount={unreadCount}
        onCheckIn={onCheckIn}
      />
      {children}
    </View>
  );
}
